<div class="dialog">
    <div class="dialog-header">+报告</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page text-right" [style.width]="120 + 'px'">
                    <span class="color-danger">*</span> 荷载试验报告
                </div>
                <div class="column" [style.width]="420 + 'px'">
                    <file-preview-entry (fileResponseChange)="onFileChange($event)" [fileType]="fileType"
                        [fileList]="fileUrls ?? []" [limit]="1" [required]="true">
                    </file-preview-entry>
                </div>
            </div>
            <div class="row validate">
                <div class="column background-page text-right" [style.width]="120 + 'px'">
                    <span class="color-danger">*</span> 报告编号
                </div>
                <div class="column" [style.width]="420 + 'px'">
                    <input type="text" placeholder="输入报告编号" [(ngModel)]="record.fileSn">
                </div>
            </div>
        </div>

        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="540 + 'px'">
                    选择本试验报告包含的桥梁工程
                </div>
            </div>
            <div class="row" *ngFor="let item of dwList">
                <div class="column text-left" [style.width]="540 + 'px'">
                    <label>
                        <input type="checkbox" [(ngModel)]="item.checked">
                        {{item.label}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>